<template>
  <v-app-bar
    :color="backgroundColor"
    class="left-menu-opacity"
  >
    <v-toolbar-title class="w-full text-left">
      <companyList
        v-if="($cookies.get('user-admin-yn-origin') === 'Y' || ($cookies.get('user-admin-yn-origin') === 'N' && $cookies.get('comp-repo-use-yn-origin') === 'Y'))"
        class="ml-7"
        @change-company="changeCompany($event)"
        @refresh-page="refreshPage($event)"
      />
      <v-btn
        v-else-if="$cookies.get('user-admin-yn') === 'N'"
        class="ml-10"
        small
        text
      >
        <v-avatar
          :color="getColorFromText($cookies.get('comp-name'))"

          size="20"
          class="font-extrabold font-avatar bg-blur mr-2"
          >
          {{ $cookies.get('comp-name').substring(0, 1) }}
        </v-avatar>
        {{ $cookies.get('comp-name') }}
      </v-btn>
    </v-toolbar-title>
    <v-toolbar-title class="w-full text-center font-extrabold">
      <v-row v-if="!isDlb">
        <v-col>
          <v-img  
            width="165.21px" style="margin: 0 auto"
            src="@/vue-caas/assets/top-menu-title.svg"
          ></v-img>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <font class="white--text-title">Data</font> <font class="white--text-title">Learning</font> <font class="light-blue--text">Bot</font>
        </v-col>
      </v-row>
    </v-toolbar-title>
    <v-toolbar-title class="w-full text-right">

      <template>
          <v-menu
            offset-y
            :close-on-content-click="false"
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on, value }">
              <v-chip
                v-on="on"
                class="cursor-pointer"
                label
                :color="backgroundColor"
              >
                <v-avatar color="white" size="26" class="text-extrabold mr-2 black--text">
                  {{ getUserNm.substring(0, 1).toUpperCase() }}
                </v-avatar>
                <span class="text-sm mr-2 white--text">{{ getUserNm }}</span>
                <v-icon x-small class="white--text" :class="`${value ? 'fa-rotate-270' : ''}`">fa fa-chevron-right</v-icon>
              </v-chip>
            </template>
            <v-list dense class="text-sm">
              <v-list-item @click="$refs.myAccount.dialog = true" class="cursor-pointer text-sm">
                <v-list-item-icon class="mr-3">
                  <v-icon
                    x-small
                  >
                    fa fa-user
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>My Account</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="checkExpireTime()" class="cursor-pointer text-sm">
                <v-list-item-icon class="mr-3 pt-1">
                  <v-icon
                    x-small
                  >
                    fas fa-sign-out-alt
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="changeTheme()" class="cursor-pointer text-sm">
                <v-list-item-icon class="mr-3">
                  <v-icon
                    x-small
                    :color="getIconColor"
                  >
                    {{ getIcon }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ getTheme }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
      </template>
    </v-toolbar-title>
    <dialogWindow
      ref="LogOut"
      title="Logout"
      size="max"
      :detail="$t('msg.clickLogout')"
      color="confirmation"
      :showCancel="true"
      @select-ok="logout()"
    >
    </dialogWindow>
    <myAccount
      ref="myAccount"
    >
    </myAccount>
  </v-app-bar>
</template>

<script>
import companyList from '@/vue-caas/views/company/CompanyList.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import myAccount from '@/vue-caas/views/user/MyAccount.vue';
import config from '@/vue-caas/config/config.js';

export default {
  components: {
    companyList,
    dialogWindow,
    myAccount,
  },

  data: () => ({
    compIdTxt: '',
    userNmTxt: '',
    isDlb: false,
  }),

  created() {
    this.compIdTxt = $cookies.get('comp-name');
    this.userNmTxt = $cookies.get('user-name');
    this.isDlb = config.isDlb;
    this.isAgent = config.isAgent;
  },

  computed: {
    backgroundColor() {
      //return this.$vuetify.theme.dark ? '#2C2C2C' : '#253C51';
      return this.$vuetify.theme.dark ? '#191A20' : '#242A33';
    },

    iconColor() {
      // return this.$vuetify.theme.dark ? '#2A2C35' : '#d6d4ca';
      return this.$vuetify.theme.dark ? '#a3a197' : '#d6d4ca';
    },

    getTheme() {
      return this.$vuetify.theme.dark ? 'Light' : 'Dark';
    },

    getIcon(){
      return this.$vuetify.theme.dark ? 'fas fa-sun' : 'fas fa-moon';
    },

    getIconColor(){
      return this.$vuetify.theme.dark ? '#E4D354' : '#7D838D';
    },

    getCompId() {
      return this.compIdTxt;
    },

    getUserNm() {
      return this.userNmTxt;
    },
  },

  methods: {

    checkExpireTime(){

      const hash = $cookies.get('hash');
      this.$http.defaults.headers.common['hash'] = hash;

      // Check session by session-manager application.
      this.$http.post(`${config.sessionApiUrl}/session/info`, { "hash": hash }).then(() => {
        this.$refs.LogOut.dialog = true;
      }).catch(() => {
        this.$router.push('/login');  
      });
    },

    async logout() {
      // don't call api if login with token
      await this.$store.dispatch('logoutUserLoginHistory');
      if (this.$cookies.get('auth-token') === 'Y') {
        this.$cookies.remove('hash');
        // Add by April for DLB  2020.06.10
        this.$cookies.remove('user-admin-yn');
        this.$cookies.remove('comp-repo-use-yn');
        this.$cookies.remove('comp-adminrepo-use-yn');
        this.$cookies.remove('comp-id');
        this.$cookies.remove('comp-name');
        this.$cookies.remove('user-id');
        this.$cookies.remove('user-name');
        // this.$cookies.remove('ui-theme');  // User정보 - 선택 테마
        this.$cookies.remove('gmt-timezone');  // User정보 - GMT 시간
        this.$cookies.remove('date-format');  // User정보 - 날짜 포멧
        this.$cookies.remove('country-code');  // User정보 - 국가정보 (언어정보)
        this.$cookies.remove('use-grade');  // User정보 - 사용자 등급
        this.$cookies.remove('menu-auth'); // 메뉴 권한 정보 (json 형식의 파일)
        this.$cookies.remove('auth-token');
        this.$http.defaults.headers.common['hash'] = '';
        this.$router.push('/login');
      } else if (this.$cookies.get('hash')) {
        this.$store.dispatch('membership/logout', { hash: this.$cookies.get('hash') }).then(() => {
          this.$cookies.remove('hash');
          // Add by April for DLB  2020.06.10
          this.$cookies.remove('user-admin-yn');
          this.$cookies.remove('comp-repo-use-yn');
          // 2023.10.11
          this.$cookies.remove('user-admin-yn-origin');
          this.$cookies.remove('comp-repo-use-yn-origin');
          this.$cookies.remove('comp-adminrepo-use-yn');
          this.$cookies.remove('comp-id');
          this.$cookies.remove('comp-name');
          this.$cookies.remove('user-id');
          this.$cookies.remove('user-name');
          // this.$cookies.remove('ui-theme');  // User정보 - 선택 테마
          this.$cookies.remove('gmt-timezone');  // User정보 - GMT 시간
          this.$cookies.remove('date-format');  // User정보 - 날짜 포멧
          this.$cookies.remove('country-code');  // User정보 - 국가정보 (언어정보)
          this.$cookies.remove('use-grade');  // User정보 - 사용자 등급
          this.$cookies.remove('menu-auth'); // 메뉴 권한 정보 (json 형식의 파일)
          this.$cookies.remove('auth-token');
          this.$http.defaults.headers.common['hash'] = '';
          this.$router.push('/login');
        });
      } else {
        this.$router.push('/login');
      }
    },

    changeTheme() {

      let ifra = document.getElementById('ifrList');


      if (this.$vuetify.theme.dark) {
        this.$vuetify.theme.dark = false;
        this.$vuetify.theme.light = true;
        this.$cookies.set('ui-theme', 'light', '12h');
        if(ifra !== null){
          ifra.contentWindow.postMessage({ parentData : 'light'}, '*');
        }
      } else if (this.$vuetify.theme.light) {
        this.$vuetify.theme.dark = true;
        this.$vuetify.theme.light = false;
        this.$cookies.set('ui-theme', 'dark', '12h');
        if(ifra !== null){
          ifra.contentWindow.postMessage({ parentData : 'dark'}, '*');
        }
      }
    },

    changeCompany(compNm) {
      this.compIdTxt = compNm;
    },

    getColorFromText(text) {
      let colorCode = (text.charCodeAt(0) * text.charCodeAt(0) * text.charCodeAt(0) * text.charCodeAt(0) * 0xffffff).toString(16).substring(0, 6);
      // alert("text : " + text + "\ntext.charCodeAt(0) : " + text.charCodeAt(0) + "\ncolor code : " + colorCode);
      // alert((15).toString(16));
      return '#' + colorCode;
    },

    refreshPage(event) {
      this.$emit('refresh-page', event);
    },
  },
}

</script>

<style>
.white--text-title{
  color: #ffffff;
}
</style>
